import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '@/lib/api-error'

/**
 * Server-state defaults for an operations console.
 *
 * The legacy app hand-rolled a session cache with in-flight dedup and neighbour
 * prefetch three times over (useDeposits, useTransactions, usePayments). All of
 * that is standard behaviour here.
 *
 * `staleTime` is deliberately short rather than zero: operators page back and
 * forth through the same filtered views constantly, so a few seconds of reuse
 * removes most of the perceived latency, while anything longer risks showing a
 * stale balance or fulfilment state after someone else has acted on it.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 10_000,
            gcTime: 5 * 60_000,
            retry: (failureCount, error) => {
                // Auth and validation failures will never succeed on retry.
                if (error instanceof ApiError && !error.isRetryable) return false
                return failureCount < 2
            },
            refetchOnWindowFocus: true,
            refetchOnReconnect: true
        },
        mutations: {
            // Mutations here move money and stock; a blind retry could double-apply.
            retry: false
        }
    }
})
